Object.defineProperty(exports,"__esModule",{value:true});exports.AlertContext=void 0;var _react=require("react");var AlertContext=(0,_react.createContext)({});exports.AlertContext=AlertContext;
//# sourceMappingURL=Context.js.map